import { isEmpty } from 'ramda';
import type {
    BillingPersonalizationTariffLine,
    BillingPersonalizationTariffLines,
} from 'reactApp/api/billing/personalization/BillingPersonalizationAPICall.types';
import {
    type BillingPersonalizationTariffs,
    type BillingPersonalizationTariffsData,
    BillingPersonalizationTypeToTabName,
} from 'reactApp/modules/billingPersonalization/billingPersonalization.types';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

// С апи приходят списки тарифов с ключами m:, y: вместо year:, month:. Нормализируем для удобства.
export const normalizeBillingPersonalizationTariffsData = (
    data?: BillingPersonalizationTariffLines
): BillingPersonalizationTariffsData | undefined => {
    if (!data) {
        return undefined;
    }

    const { default: defaultData, ...rest } = data;

    const output: BillingPersonalizationTariffsData = {
        default: { ...defaultData },
    };

    Object.keys(rest).forEach((item) => {
        const tariff = rest[item] as BillingPersonalizationTariffLine;

        if (isEmpty(tariff)) {
            return;
        }

        output[item] = {
            ...tariff,
            list: {
                year: tariff.list.y,
                month: tariff.list.m,
            },
        };
    });

    return output;
};

export const getBillingPersonalizationTariffsByTab = (data?: BillingPersonalizationTariffsData): BillingPersonalizationTariffs => {
    const tariffs: BillingPersonalizationTariffs = {};

    if (!data) {
        return {};
    }

    Object.keys(data).forEach((type) => {
        // проверяем, что поле с тарифами, а не default
        if (data[type]?.list) {
            // кладем по ключу таба
            const tabName = BillingPersonalizationTypeToTabName[type] as ETabsName;
            tariffs[tabName] = data[type].list;
        }
    });

    return tariffs;
};
